import { Field, Form, Formik } from "formik";
import { useEffect, useRef, useState } from "react";
import { FaSearch } from "react-icons/fa";
import { useDispatch, useSelector } from "react-redux";
import {
  Alert,
  Col,
  Input,
  InputGroup,
  InputGroupText,
  Row,
  Spinner,
} from "reactstrap";
import FilterComponenent from "./Filter";
import PaginationComponent from "./Paginations";
import PlayerInfo from "pages/Joueurs/companents/PlayerInfo";
import { getAllPlayers, setCurrentPage } from "store/slices/agentPlayerSlice";
import AgentPlayerInfo from "pages/Joueurs/companents/AgentPlayerInfo";

const SearchAgent = () => {
  const dispatch = useDispatch();
  const [searchValue, setSearchValue] = useState("");

  const {
    players,
    loading,
    error,
    totalPlayers,
    currentPage,
    totalPages,
    fetchLoading,
  } = useSelector((state) => state.AgentPlayer);
  console.log("players: ", players);

  const listRef = useRef(null);
  const firstRender = useRef(true);

  useEffect(() => {
    dispatch(
      getAllPlayers({
        page: currentPage,
        firstName: searchValue,
        lastName: searchValue,
        limit: 8,
      })
    ).then(() => {
      if (!firstRender.current) {
        listRef.current?.scrollIntoView({ behavior: "smooth" });
      } else {
        firstRender.current = false;
      }
    });
  }, [dispatch, currentPage, searchValue]);

  if (loading) return <Spinner />;
  if (error) return <Alert color="danger">{error.message}</Alert>;

  return (
    <Col lg={9} style={{ marginTop: 25 }}>
      <Row>
        <Formik
          initialValues={{ search: "" }}
          onSubmit={({ search }) => {
            setSearchValue(search);
            if (currentPage !== 1) {
              dispatch(setCurrentPage(1));
            }
          }}
        >
          {({ handleSubmit }) => (
            <Form onSubmit={handleSubmit}>
              <div
                style={{
                  position: "relative",
                  width: "100%",
                  borderRadius: 10,
                }}
              >
                <Field
                  name="search"
                  as={Input}
                  placeholder="search by firstName or lastName"
                  style={{
                    paddingRight: "30px",
                    borderRadius: 15,
                    border: "1 solid #000000",
                  }}
                />
                <FaSearch
                  onClick={handleSubmit}
                  style={{
                    position: "absolute",
                    right: "10px",
                    top: "50%",
                    transform: "translateY(-50%)",
                    cursor: "pointer",
                    color: "#000000",
                  }}
                />
              </div>
            </Form>
          )}
        </Formik>
      </Row>

      <Row>
        <div ref={listRef}>
          {fetchLoading ? (
            <div style={{ textAlign: "center", padding: "20px" }}>
              <Spinner color="primary" />
            </div>
          ) : players && players?.length > 0 ? (
            players?.map((player) => (
              <AgentPlayerInfo key={player.id} player={player} />
            ))
          ) : (
            <div style={{ marginTop: 20 }}>Aucun joueur trouvé.</div>
          )}
        </div>
      </Row>
      <PaginationComponent
        totalItems={totalPlayers}
        totalPages={totalPages}
        currentPage={currentPage}
        setCurrentPage={setCurrentPage}
      ></PaginationComponent>
    </Col>
  );
};

export default SearchAgent;
